import axios from "axios";
import React, { useEffect, useState } from "react";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AuditionCompletedView from "./AuditionCompletedView";

import cup from "../../../../../assets/images/pending3.png";
import LoaderPost from "../../../../Reuseable/LoaderPost";
const CompleteAuditionSliderStar = () => {
  const [auditions, setAllAudition] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/superstar/audition/view`).then((res) => {
      setBuffer(false);
      if (res.status == 200) {
        setAllAudition(res.data?.auditions);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live Auditions" image={cup} count={"Zero"} />
      {buffer ? <LoaderPost /> : <AuditionCompletedView data={auditions} />}
    </>
  );
};

export default CompleteAuditionSliderStar;
